

export enum CaseParticipantPrivileges {
    None = 0,
    Read = 1,
    Edit = 2
}
